<template>
    <app-transition>
        <Dialog @close="handleClose" class="age-verification-dialog">
            <v-row>
                <h2>{{ $t('dialogs.verify_your_age') }}</h2>
            </v-row>
            <v-row text-center="">
                <v-col>
                    <div class="VerifyMessage-title font-weight-bold text">
                        <p >
                            {{ $t('dialogs.verify_your_age_desc', { country: displayCountryName } ) }}
                        </p>
                    </div>
                </v-col>
            </v-row>
            <v-row text-center="">
                <v-col>
                    <div class="VerifyMessage-title font-weight-bold text">
                        <div>
                            {{ $t('dialogs.verify_your_age_desc1') }}
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-btn outlined block height="50" @click="toVerificationUserLink">{{ $t('dialogs.verify_now') }}</v-btn>
                </v-col>
            </v-row>
        </Dialog>
    </app-transition>
</template>

<script>
import {mapGetters} from "vuex";
import Dialog from "@/components/app/form/Dialog";
import { RULE_COUNTRY } from "../../../configs/constants";

export default {
    name: "AgeVerifyDialog",
    computed: {
        ...mapGetters([
            'nextStepVerificationRouteName'
        ]),
          displayCountryName() {
            return RULE_COUNTRY.includes(this.countryName.geographic_region)
            ? this.countryName.geographic_region_name
            : this.countryName.regionName
        }
    },
    data() {
        return {
            loading: {
                verificationUser: false,
            },
            verificationUser: {status: null, date: null},
        }
    },
    props: {
        countryName: {
            type: Object,
            default: {}
        },
    },
    methods: {
        handleClose() {
            this.$emit('close');
        },
        toVerificationUserLink() {
            this.loading.verificationUser = true
            return window.axios('api/ondato/verification-user-link')
                .then(({data}) => window.location.href = data.redirectUrl)
                .catch(e => {
                    this.showSnackBar(e.response?.data?.message || 'Something went wrong.');
                })
                .finally(() => this.loading.verificationUser = false)
        },
    },
    components: {
        Dialog,
    }
}
</script>

<style scoped lang="scss">
@import '@/sass/modules/_variables';

.VerifyMessage {
    &-title {
        font-size: 20px;
        font-weight: bold;
        line-height: 19px;
        width: 100%;
        a {
            text-decoration: underline;
        }
    }
}
.age-verification-dialog {
  position: fixed !important;
  z-index: 999999 !important;
}

</style>
